// @ts-nocheck
import {Column} from 'react-table'
import {InfoCell} from './InfoCell'
import {DateCell} from './DateCell'
import {StatusCell} from './StatusCell'
import {ApprovalStatusCell} from './ApprovalStatusCell'
import {ActionsCell} from './ActionsCell'
import {SelectionCell} from './SelectionCell'
import {CustomHeader} from './CustomHeader'
import {SelectionHeader} from './SelectionHeader'
import {ClassifiedPost} from '../../core/_models'
import {format} from 'date-fns'
import {PriceCell} from './PriceCell'
import {CategoryCell} from './CategoryCell'

const classifiedColumns: ReadonlyArray<Column<ClassifiedPost>> = [
  {
    Header: (props) => <SelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({...props}) => <SelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Post' className='min-w-200px' />,
    id: 'title',
    Cell: ({...props}) => (
      <InfoCell post={props.data[props.row.index]} id={props.data[props.row.index].id} />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Category' className='min-w-125px' />
    ),
    id: 'category',
    Cell: ({...props}) => <CategoryCell post={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Price' className='min-w-100px' />,
    id: 'price',
    Cell: ({...props}) => <PriceCell post={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Approval' className='min-w-125px' />
    ),
    id: 'approvalStatus',
    Cell: ({...props}) => (
      <ApprovalStatusCell approvalStatus={props.data[props.row.index].approvalStatus} />
    ),
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Status' className='min-w-100px' />,
    id: 'status',
    Cell: ({...props}) => <StatusCell status={props.data[props.row.index].status} />,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Created Date' className='min-w-125px' />
    ),
    id: 'createdAt',
    Cell: ({...props}) => {
      const dateString: string = props.data[props.row.index].createdAt
      const createdDate = format(new Date(dateString), 'MMM dd, yyyy')
      return <DateCell date={createdDate} />
    },
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Actions' className='text-end min-w-150px' />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <ActionsCell
        id={props.data[props.row.index].id}
        post={props.data[props.row.index]}
        isDeleted={!!props.data[props.row.index]?.deletedAt}
      />
    ),
  },
]

export {classifiedColumns}

